<template>
  <PainelLayout>
    <Breadcrumb class="print-no-show" :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Locações', 'link' : '/rental' },
      ]"
    />

    <div class="moviment-page" v-if="dados.id != null && loading == false">

      <!-- Cabeçalho -->
      <div class="page-head print-no-show">
        <div>
          <span class="eyebrow">Locação #{{ dados.id }}</span>
          <h1>Confirmar movimentação</h1>
        </div>
        <span class="status-badge" :class="'is-' + statusVariant(dados.status)" v-if="currentAction">
          <i class="bi" :class="currentAction.icon"></i>
          {{ currentAction.label }}
        </span>
      </div>

      <!-- Cabeçalho exclusivo para impressão -->
      <div class="header-print">
        <h1>Movimentação — Locação #{{ dados.id }}</h1>
        <small>Impresso em {{ dateFormat.dateTime(new Date()) }}</small>
      </div>

      <div id="conteudoParaImprimir">

        <!-- Resumo -->
        <div class="hero-card">
          <div class="hero-top">
            <div>
              <span class="eyebrow">Cliente</span>
              <h2 class="client-name">{{ dados.cliente.name }}</h2>
            </div>
            <div class="value-block value-block-main">
              <span class="value-label">Valor final</span>
              <span class="value-amount">R$ {{ dados.final_amount.toFixed(2) }}</span>
            </div>
          </div>

          <div class="hero-divider"></div>

          <div class="hero-meta">
            <div class="meta-item" v-if="dados.withdrawal">
              <i class="bi bi-mailbox2-flag"></i>
              <div>
                <span class="meta-label">Entrega</span>
                <span class="meta-value">Retirada na loja</span>
              </div>
            </div>
            <template v-else>
              <div class="meta-item">
                <i class="bi bi-geo-alt"></i>
                <div>
                  <span class="meta-label">Endereço</span>
                  <span class="meta-value">{{ dados.address }}{{ dados.number ? ', ' + dados.number : '' }}</span>
                </div>
              </div>
              <div class="meta-item">
                <i class="bi bi-signpost-2"></i>
                <div>
                  <span class="meta-label">Cidade</span>
                  <span class="meta-value">{{ dados.city }}{{ dados.state ? '/' + dados.state : '' }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- Itens -->
        <div class="section-card">
          <h3><i class="bi bi-box-seam"></i> Itens</h3>
          <p class="section-hint">Marque os itens conferidos nesta movimentação e ajuste a quantidade se necessário.</p>
          <table class="items-table">
            <thead>
              <tr>
                <th class="check-col"></th>
                <th>Nome</th>
                <th class="text-end">Quantidade</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in dados.items" :key="item.id">
                <td class="check-col">
                  <input
                    class="item-check"
                    required
                    :name="'item[' + item.id + ']'"
                    type="checkbox"
                    :true-value="item.name + ' - ' + item.quant"
                    :false-value="null"
                    v-model="listaitens[item.id]"
                  />
                </td>
                <td>{{ item.name }}</td>
                <td class="text-end">
                  <div class="qty-stepper print-no-show">
                    <button type="button" @click="decrementQuantity(item.id)" aria-label="Diminuir">
                      <i class="bi bi-dash"></i>
                    </button>
                    <span class="qty-value">{{ item.quant }}</span>
                    <button type="button" @click="incrementQuantity(item.id)" aria-label="Aumentar">
                      <i class="bi bi-plus"></i>
                    </button>
                  </div>
                  <span class="qty-print-only">{{ item.quant }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Fotos -->
        <div class="section-card print-no-show">
          <h3><i class="bi bi-camera-fill"></i> Fotos</h3>
          <p class="section-hint">Anexe quantas fotos forem necessárias para registrar o estado dos itens.</p>

          <label
            class="dropzone"
            :class="{ 'is-dragover': dragOver }"
            @dragover.prevent="dragOver = true"
            @dragleave.prevent="dragOver = false"
            @drop.prevent="handleDrop"
          >
            <input
              class="dropzone-input"
              type="file"
              accept="image/*"
              multiple
              @change="handleFileSelect"
            />
            <i class="bi bi-cloud-arrow-up"></i>
            <span><strong>Clique para escolher</strong> ou arraste as fotos aqui</span>
            <small>PNG ou JPG, até 8MB cada</small>
          </label>

          <div class="photo-grid" v-if="photos.length">
            <div class="photo-thumb" v-for="(photo, idx) in photos" :key="photo.id">
              <img :src="photo.preview" :alt="photo.file.name" />
              <button type="button" class="photo-remove" @click="removePhoto(idx)" aria-label="Remover foto">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
          <p class="photo-empty" v-else>Nenhuma foto adicionada ainda.</p>
        </div>

        <!-- Observação -->
        <div class="section-card">
          <h3><i class="bi bi-chat-left-text"></i> Observação</h3>
          <textarea
            v-model="note"
            name="note"
            class="note-input"
            rows="3"
            placeholder="Observação opcional sobre esta movimentação"
          ></textarea>
        </div>

        <!-- Ações -->
        <div class="action-bar print-no-show">
          <router-link class="btn-ghost" :to="{ path: '/rental/details', query: { id: dados.id } }">
            <i class="bi bi-x-octagon"></i> Cancelar
          </router-link>
          <button
            v-if="currentAction"
            class="btn-solid"
            :disabled="sending"
            @click="sendMovimentacao(currentAction.to, currentAction.type)"
          >
            <span v-if="sending" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <template v-else>
              <i class="bi" :class="currentAction.icon"></i> {{ currentAction.label }}
            </template>
          </button>
        </div>

      </div>
      <div style="height: 60px; color: transparent;">.</div>
    </div>

    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { rental } from '@/models/rental';
import { onMounted, onBeforeUnmount, ref, reactive, computed } from 'vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import dateFormat from '@/services/dateFormat.js';
import statusFormat from '@/services/statusFormat';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import router from '@/router';

export default {
  name: "MovimentacaoView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const query = window.location.search;
    const urlParams = new URLSearchParams(query);
    const id = urlParams.get('id');
    const toastStore = useToastStore();
    var loading = ref(false);
    var sending = ref(false);
    const model = rental();

    var listaitens = ref([]);
    var note = ref('');

    // Foto(s) selecionadas para envio junto com a movimentação
    var photos = ref([]);
    var dragOver = ref(false);
    var photoIdSeq = 0;
    const MAX_PHOTO_SIZE = 8 * 1024 * 1024; // 8MB

    var dados = reactive({
      cliente: {name:'AVULSO'},
      items: [],
      id : null,
      discount: 0,
      percent: 0,
      total_amount: 0,
      final_amount: 0,
      rental_date_start: '',
      rental_time_start: '00:00',
      rental_date_end: '',
      rental_time_end: '23:59',
      days_amount: 1,
      status: null,
      withdrawal: false,
      address: '',
      number: '',
      neighbor: '',
      city: '',
      state: '',
      zipcode: '',
      note: ''
    })

    // Mapeia o status atual para a ação de confirmação correspondente
    const statusActionMap = {
      PENDING_DELIVERY:       { to: 'ACTIVE',    type: 'DELIVERED',        label: 'Concluir entrega',      icon: 'bi-truck' },
      PENDING_PICKUP:         { to: 'ACTIVE',    type: 'PICKED_UP',        label: 'Concluir retirada',     icon: 'bi-box-arrow-left' },
      PENDING_COMPANY_PICKUP: { to: 'COMPLETED', type: 'COMPANY_PICKED_UP', label: 'Concluir recolhimento', icon: 'bi-box-seam' },
      PENDING_RETURN:         { to: 'COMPLETED', type: 'RETURNED',         label: 'Concluir devolução',    icon: 'bi-check-square' },
    };

    const currentAction = computed(() => statusActionMap[dados.status] || null);

    function statusVariant(status) {
      switch (status) {
        case 'PENDING_DELIVERY':
        case 'PENDING_PICKUP':
          return 'pending';
        case 'ACTIVE':
          return 'active';
        case 'PENDING_RETURN':
        case 'PENDING_COMPANY_PICKUP':
          return 'returning';
        case 'COMPLETED':
          return 'completed';
        case 'CANCELLED':
          return 'cancelled';
        default:
          return 'neutral';
      }
    }

    function imprimir() {
      window.print();
    }

    onMounted(() => {
      loading.value = true;
      model.getOne(id).then((response) => {
        dados.id = response.id;
        dados.cliente = response.client;
        dados.items = response.items;
        dados.listaitens = response.listaitens;
        dados.discount = response.discount;
        dados.percent = response.percent;
        dados.total_amount = response.total_amount;
        dados.final_amount = response.final_amount;
        dados.rental_date_start = response.rental_date_start;
        dados.rental_time_start = response.rental_time_start;
        dados.rental_date_end = response.rental_date_end;
        dados.rental_time_end = response.rental_time_end;
        dados.days_amount = response.days_amount;
        dados.withdrawal = response.withdrawal;
        dados.address = response.address;
        dados.number = response.number;
        dados.neighbor = response.neighbor;
        dados.city = response.city;
        dados.state = response.state;
        dados.status = response.status;
        dados.zipcode = response.zipcode;
        dados.note = response.note;

        loading.value = false;
      }).catch((error) => {
        loading.value = false;
        toastStore.error('Erro ao carregar dados da movimentação: ' + parseError(error));
      });
    });

    onBeforeUnmount(() => {
      photos.value.forEach(p => URL.revokeObjectURL(p.preview));
    });

    function incrementQuantity(itemId) {
      const item = dados.items.find(i => i.id === itemId);
      if (item) {
        item.quant++;
        listaitens.value[itemId] = item.name + ' - ' + item.quant;
      }
    }

    function decrementQuantity(itemId) {
      const item = dados.items.find(i => i.id === itemId && i.quant > 0);
      if (item) {
        item.quant--;
        listaitens.value[itemId] = item.name + ' - ' + item.quant;
      }
    }

    // --- Fotos ---
    function addFiles(fileList) {
      Array.from(fileList || []).forEach(file => {
        if (!file.type.startsWith('image/')) {
          toastStore.error('Arquivo "' + file.name + '" não é uma imagem.');
          return;
        }
        if (file.size > MAX_PHOTO_SIZE) {
          toastStore.error('A foto "' + file.name + '" excede 8MB.');
          return;
        }
        photos.value.push({
          id: photoIdSeq++,
          file,
          preview: URL.createObjectURL(file)
        });
      });
    }

    function handleFileSelect(event) {
      addFiles(event.target.files);
      event.target.value = '';
    }

    function handleDrop(event) {
      dragOver.value = false;
      addFiles(event.dataTransfer.files);
    }

    function removePhoto(idx) {
      URL.revokeObjectURL(photos.value[idx].preview);
      photos.value.splice(idx, 1);
    }

    function sendMovimentacao(status, type) {
      sending.value = true;
      var description = Object.values(listaitens.value).filter(Boolean).join(', ');
      var photoFiles = photos.value.map(p => p.file);

      model.sendMovimentacao(dados.id, status, type, note.value, description, photoFiles).then((response) => {
        if (response) {
          toastStore.success('Movimentação concluída com sucesso!');
          router.push('/rental/details?id=' + dados.id);
        } else {
          toastStore.error('Erro ao enviar movimentação.');
        }
        sending.value = false;
      }).catch((error) => {
        sending.value = false;
        toastStore.error('Erro ao enviar movimentação: ' + parseError(error));
      });
    }

    return {
      dados, dateFormat, statusFormat, loading, sending, imprimir, listaitens, note,
      photos, dragOver, currentAction, statusVariant,
      incrementQuantity, decrementQuantity,
      handleFileSelect, handleDrop, removePhoto,
      sendMovimentacao
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=Inter:wght@400;500;600&display=swap');

.moviment-page {
  --ink: #16223A;
  --ink-soft: #4B5A72;
  --line: #E4E8EF;
  --surface: #FFFFFF;
  --canvas: #F3F5F8;
  --brand: #1E4B6B;
  --brand-soft: #EAF1F6;
  --amber: #B4790E;
  --amber-soft: #FBF1DE;
  --teal: #167A5B;
  --teal-soft: #E4F5EE;
  --blue: #2E5FA3;
  --blue-soft: #E9F0FA;
  --gray: #64748B;
  --gray-soft: #EEF1F5;
  --red: #B3362C;
  --red-soft: #FBEAE8;
  font-family: 'Inter', sans-serif;
  color: var(--ink);
}

.moviment-page h1, .moviment-page h2, .moviment-page h3 {
  font-family: 'Manrope', sans-serif;
  margin: 0;
}

.eyebrow {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-soft);
  margin-bottom: 2px;
}

/* Cabeçalho */
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 8px 0 20px;
  flex-wrap: wrap;
  gap: 12px;
}
.page-head h1 {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--ink);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 999px;
  white-space: nowrap;
}
.status-badge.is-pending { background: var(--amber-soft); color: var(--amber); }
.status-badge.is-active { background: var(--teal-soft); color: var(--teal); }
.status-badge.is-returning { background: var(--blue-soft); color: var(--blue); }
.status-badge.is-completed { background: var(--gray-soft); color: var(--gray); }
.status-badge.is-cancelled { background: var(--red-soft); color: var(--red); }
.status-badge.is-neutral { background: var(--gray-soft); color: var(--gray); }

/* Hero */
.hero-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 24px 28px;
  margin-bottom: 16px;
}
.hero-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}
.client-name {
  font-size: 1.35rem;
  font-weight: 700;
}
.value-label {
  display: block;
  font-size: 0.72rem;
  color: var(--ink-soft);
  font-weight: 600;
  margin-bottom: 2px;
  text-align: right;
}
.value-amount {
  font-family: 'Manrope', sans-serif;
  font-size: 1.6rem;
  font-weight: 800;
  color: var(--brand);
}

.hero-divider {
  height: 1px;
  background: var(--line);
  margin: 18px 0;
}

.hero-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}
.meta-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.meta-item i {
  color: var(--brand);
  font-size: 1.05rem;
  margin-top: 2px;
}
.meta-label {
  display: block;
  font-size: 0.72rem;
  color: var(--ink-soft);
}
.meta-value {
  display: block;
  font-weight: 600;
  font-size: 0.92rem;
}

/* Cards de seção */
.section-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 20px 22px;
  margin-bottom: 16px;
}
.section-card h3 {
  font-size: 0.95rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  color: var(--ink);
}
.section-card h3 i { color: var(--brand); }
.section-hint {
  font-size: 0.82rem;
  color: var(--ink-soft);
  margin: 0 0 14px;
}

/* Tabela de itens */
.items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}
.items-table th {
  text-align: left;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ink-soft);
  font-weight: 700;
  padding: 8px 10px;
  border-bottom: 1px solid var(--line);
}
.items-table td {
  padding: 10px;
  border-bottom: 1px solid var(--line);
  vertical-align: middle;
}
.items-table tr:last-child td { border-bottom: none; }
.text-end { text-align: right; }
.check-col { width: 34px; }

.item-check {
  width: 18px;
  height: 18px;
  accent-color: var(--brand);
  cursor: pointer;
}

.qty-stepper {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: var(--canvas);
  border-radius: 999px;
  padding: 4px;
}
.qty-stepper button {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  background: var(--surface);
  color: var(--brand);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(22, 34, 58, 0.08);
}
.qty-stepper button:hover { background: var(--brand-soft); }
.qty-value {
  min-width: 18px;
  text-align: center;
  font-weight: 700;
}
.qty-print-only { display: none; font-weight: 700; }

/* Dropzone de fotos */
.dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  border: 1.5px dashed var(--line);
  border-radius: 12px;
  padding: 28px 16px;
  cursor: pointer;
  color: var(--ink-soft);
  background: var(--canvas);
  transition: border-color .15s ease, background .15s ease;
  overflow: hidden;
}
.dropzone:hover, .dropzone.is-dragover {
  border-color: var(--brand);
  background: var(--brand-soft);
  color: var(--brand);
}
.dropzone i {
  font-size: 1.6rem;
  color: var(--brand);
}
.dropzone span { font-size: 0.9rem; }
.dropzone small { font-size: 0.75rem; }
.dropzone-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 12px;
  margin-top: 16px;
}
.photo-thumb {
  position: relative;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--line);
}
.photo-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.photo-remove {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: rgba(22, 34, 58, 0.75);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  cursor: pointer;
}
.photo-remove:hover { background: var(--red); }
.photo-empty {
  margin: 14px 0 0;
  font-size: 0.82rem;
  color: var(--ink-soft);
}

/* Observação */
.note-input {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 10px 12px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  color: var(--ink);
  resize: vertical;
}
.note-input:focus {
  outline: none;
  border-color: var(--brand);
  box-shadow: 0 0 0 3px var(--brand-soft);
}

/* Ações */
.action-bar {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
}
.btn-ghost, .btn-solid {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 0.88rem;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink);
  text-decoration: none;
  cursor: pointer;
  transition: border-color .15s ease, background .15s ease;
}
.btn-ghost:hover { border-color: var(--red); color: var(--red); }
.btn-solid {
  background: var(--ink);
  color: #fff;
  border-color: var(--ink);
}
.btn-solid:hover { background: #0E1930; }
.btn-solid:disabled { opacity: 0.7; cursor: not-allowed; }

/* Impressão */
.header-print { display: none; }

@media print {
  body * { visibility: hidden; }
  .print-no-show { display: none !important; }
  .header-print {
    display: block;
    margin-bottom: 20px;
    font-family: 'Manrope', sans-serif;
  }
  #conteudoParaImprimir, #conteudoParaImprimir * { visibility: visible; }
  #conteudoParaImprimir {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .hero-card, .section-card {
    border: 1px solid #ccc !important;
    box-shadow: none !important;
    break-inside: avoid;
  }
  table, tr, td, th { page-break-inside: avoid; }
  .qty-print-only { display: inline; }
}

@media (max-width: 576px) {
  .page-head { flex-direction: column; align-items: flex-start; }
  .hero-top { flex-direction: column; }
  .value-label, .value-amount { text-align: left; }
}
</style>